const NAMESPACE = 'facebook/';

export const FB_LOGIN = `${NAMESPACE}FB_LOGIN`;

export function facebookLogin(response) {
    return {
        type: FB_LOGIN,
        payload: {
            response
        },
    };
}

export const FB_LOGOUT = `${NAMESPACE}FB_LOGOUT`;

export function facebookLogout() {
    return {
        type: FB_LOGOUT,
        payload: {},
    };
}

export const FB_LOGIN_SUCCESS = `${NAMESPACE}FB_LOGIN_SUCCESS`;

export function facebookLoginSuccess(accessToken, userId, userName, userPicture) {
    return {
        type: FB_LOGIN_SUCCESS,
        payload: {
            accessToken,
            userName,
            userId,
            userPicture,
        },
    };
}

export const FB_LOGIN_FAILURE = `${NAMESPACE}FB_LOGIN_FAILURE`;

export function facebookLoginFailure(error) {
    return {
        type: FB_LOGIN_FAILURE,
        payload: {
            error,
        },
    };
}

export const GET_PAGES = `${NAMESPACE}GET_PAGES`;

export function getPages() {
    return {
        type: GET_PAGES,
        payload: {},
    };
}

export const GET_PAGES_SUCCESS = `${NAMESPACE}GET_PAGES_SUCCESS`;

export function getPagesSuccess(pages) {
    return {
        type: GET_PAGES_SUCCESS,
        payload: {
            pages
        },
    };
}

export const GET_PAGES_FAILURE = `${NAMESPACE}GET_PAGES_FAILURE`;

export function getPagesFailure(error) {
    return {
        type: GET_PAGES_FAILURE,
        payload: {
            error,
        },
    };
}

export const PARSE_XFBML = `${NAMESPACE}PARSE_XFBML`;

export function parseXfbml() {
    return {
        type: PARSE_XFBML,
        payload: {},
    };
}

export const PARSE_XFBML_SUCCESS = `${NAMESPACE}PARSE_XFBML_SUCCESS`;

export function parseXfbmlSuccess() {
    return {
        type: PARSE_XFBML_SUCCESS,
        payload: {},
    };
}

export const PARSE_XFBML_FAILURE = `${NAMESPACE}PARSE_XFBML_FAILURE`;

export function parseXfbmlFailure(error) {
    return {
        type: PARSE_XFBML_FAILURE,
        payload: {
            error
        },
    };
}

export const LOAD_FACEBOOK_SDK = `${NAMESPACE}LOAD_FACEBOOK_SDK`;

export function loadFacebookSDK() {
    return {
        type: LOAD_FACEBOOK_SDK,
    };
}

export const LOAD_FACEBOOK_SDK_SUCCESS = `${NAMESPACE}LOAD_FACEBOOK_SDK_SUCCESS`;

export function loadFacebookSDKSuccess() {
    return {
        type: LOAD_FACEBOOK_SDK_SUCCESS,
    };
}

export const LOAD_FACEBOOK_SDK_FAILURE = `${NAMESPACE}LOAD_FACEBOOK_SDK_FAILURE`;

export function loadFacebookSDKFailure(error) {
    return {
        type: LOAD_FACEBOOK_SDK_FAILURE,
        payload: {
            error,
        },
    };
}

export const CONNECT_IG_BUSINESS_ACCOUNT = `${NAMESPACE}CONNECT_IG_BUSINESS_ACCOUNT`;

export function connectIgBusinessAccount(organizationId, shorLivedToken, pageId) {
    return {
        type: CONNECT_IG_BUSINESS_ACCOUNT,
        payload: {
            organizationId,
            shorLivedToken,
            pageId,
        }
    };
}

export const CONNECT_IG_BUSINESS_ACCOUNT_SUCCESS = `${NAMESPACE}CONNECT_IG_BUSINESS_ACCOUNT_SUCCESS`;

export function connectIgBusinessAccountSuccess(organizationId, igAccount) {
    return {
        type: CONNECT_IG_BUSINESS_ACCOUNT_SUCCESS,
        payload: {
            organizationId,
            igAccount
        }
    };
}

export const CONNECT_IG_BUSINESS_ACCOUNT_FAILURE = `${NAMESPACE}CONNECT_IG_BUSINESS_ACCOUNT_FAILURE`;

export function connectIgBusinessAccountFailure(organizationId, error) {
    return {
        type: CONNECT_IG_BUSINESS_ACCOUNT_FAILURE,
        payload: {
            error,
            organizationId,
        },
    };
}

export const CLEAR_ERRORS = `${NAMESPACE}CLEAR_ERRORS`;

export function clearErrorState() {
    return {
        type: CLEAR_ERRORS,
        payload: {},
    };
}

export const GET_IG_BUSINESS_ACCOUNTS = `${NAMESPACE}GET_IG_BUSINESS_ACCOUNTS`;

export function getIgBusinessAccounts(organizationId, includeParents = true) {
    return {
        type: GET_IG_BUSINESS_ACCOUNTS,
        payload: {
            includeParents,
            organizationId,
        }
    };
}

export const GET_IG_BUSINESS_ACCOUNTS_SUCCESS = `${NAMESPACE}GET_IG_BUSINESS_ACCOUNTS_SUCCESS`;

export function getIgBusinessAccountsSuccess(organizationId, igAccounts) {
    return {
        type: GET_IG_BUSINESS_ACCOUNTS_SUCCESS,
        payload: {
            organizationId,
            igAccounts
        }
    };
}

export const GET_IG_BUSINESS_ACCOUNTS_FAILURE = `${NAMESPACE}GET_IG_BUSINESS_ACCOUNTS_FAILURE`;

export function getIgBusinessAccountsFailure(organizationId, error) {
    return {
        type: GET_IG_BUSINESS_ACCOUNTS_FAILURE,
        payload: {
            error,
            organizationId,
        },
    };
}

export const DISCONNECT_IG_BUSINESS_ACCOUNT = `${NAMESPACE}DISCONNECT_IG_BUSINESS_ACCOUNT`;

export function disconnectIgBusinessAccount(organizationId, pageId) {
    return {
        type: DISCONNECT_IG_BUSINESS_ACCOUNT,
        payload: {
            organizationId,
            pageId,
        }
    };
}

export const DISCONNECT_IG_BUSINESS_ACCOUNT_SUCCESS = `${NAMESPACE}DISCONNECT_IG_BUSINESS_ACCOUNT_SUCCESS`;

export function disconnectIgBusinessAccountSuccess(organizationId) {
    return {
        type: DISCONNECT_IG_BUSINESS_ACCOUNT_SUCCESS,
        payload: {
            organizationId,
        }
    };
}

export const DISCONNECT_IG_BUSINESS_ACCOUNT_FAILURE = `${NAMESPACE}DISCONNECT_IG_BUSINESS_ACCOUNT_FAILURE`;

export function disconnectIgBusinessAccountFailure(organizationId, error) {
    return {
        type: DISCONNECT_IG_BUSINESS_ACCOUNT_FAILURE,
        payload: {
            error,
            organizationId,
        },
    };
}